<template>
    <!-- Add Shipping Modal -->
    <div
        class="modal fade custom-modal"
        id="addShippingModalOther"
        ref="addShippingModalOther"
        tabindex="-1"
        aria-labelledby="shippingModalLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-lg"
            style="max-width: 900px"
        >
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="shippingModalLabel">
                        <template v-if="shipping != null">Edit</template
                        ><template v-else>Add</template> Shipping
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                <div class="modal-body">
                    <div
                        class="alert alert-success"
                        role="alert"
                        v-if="successMessage"
                    >
                        {{ successMessage }}
                    </div>

                    <div
                        v-if="commonErrors.length != 0"
                        class="alert alert-danger alert-dismissible"
                    >
                        <a
                            href="javascript:void(0);"
                            class="close"
                            data-dismiss="alert"
                            aria-label="close"
                            >&times;</a
                        >
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p
                                    v-for="error in v"
                                    :key="error"
                                    class="text-sm"
                                >
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver
                        v-slot="{ handleSubmit }"
                        ref="formValidation"
                        name="addShipping"
                    >
                        <form
                            @submit.prevent="handleSubmit(submitHandler)"
                            enctype="multipart/form-data"
                        >
                            <div class="invoiceDetails">
                                <table class="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 70px">
                                                <div
                                                    class="custom-control custom-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        id="checkAll"
                                                        name="checkAll"
                                                        v-model="checkAll"
                                                        v-on:click="
                                                            checkAllEvent(
                                                                $event
                                                            )
                                                        "
                                                    />
                                                    <label
                                                        class="custom-control-label"
                                                        for="checkAll"
                                                        >All</label
                                                    >
                                                </div>
                                            </th>
                                            <th style="width: 120px">Item #</th>
                                            <th>Product Name</th>
                                            <th style="width: 260px">
                                                Quantity
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                product, index
                                            ) in form.products.filter(
                                                (x) => x.id != null
                                            )"
                                            :key="product.id"
                                        >
                                            <td>
                                                <div
                                                    class="custom-control custom-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        :value="product.id"
                                                        :id="'id_' + product.id"
                                                        name="uns_prod_ids[]"
                                                        :checked="true"
                                                        @click="
                                                            removeProductCheckbox(
                                                                product,
                                                                $event
                                                            )
                                                        "
                                                    />
                                                    <label
                                                        class="custom-control-label"
                                                        :for="
                                                            'id_' + product.id
                                                        "
                                                    ></label>
                                                </div>
                                            </td>
                                            <td>
                                                <router-link
                                                    :to="{
                                                        name: 'productsDetails',
                                                        params: {
                                                            id: product.id,
                                                        },
                                                    }"
                                                    target="_blank"
                                                    >{{
                                                        product.product_num
                                                    }}</router-link
                                                >
                                            </td>
                                            <td>
                                                {{ product.product_name }}
                                                <p
                                                    v-html="
                                                        product.product_desc
                                                    "
                                                ></p>
                                            </td>
                                            <td>
                                                <ValidationProvider
                                                    name="Quantity"
                                                    immediate
                                                    rules="required|positive|min_value:1"
                                                    v-slot="{ errors }"
                                                >
                                                    <input
                                                        type="text"
                                                        class="form-control form-custom"
                                                        placeholder=""
                                                        v-on:keydown="
                                                            checkNumber($event)
                                                        "
                                                        v-model="
                                                            form.products[index]
                                                                .quantity
                                                        "
                                                    />
                                                    <div
                                                        class="error"
                                                        v-if="errors.length"
                                                    >
                                                        {{ errors[0] }}
                                                    </div>
                                                </ValidationProvider>

                                                <div class="row mt-2">
                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Pcs Per Case</label
                                                        >
                                                        <input
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            @input="
                                                                checkCaseNumber(
                                                                    index
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ].pcs_per_case
                                                            "
                                                        />
                                                    </div>
                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Cases Per
                                                            pallet</label
                                                        >
                                                        <input
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            @input="
                                                                checkCaseNumber(
                                                                    index
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .cases_per_pallet
                                                            "
                                                        />
                                                    </div>

                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Amount of Case</label
                                                        >
                                                        <input readonly
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            v-on:keydown="
                                                                checkNumber(
                                                                    $event
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .total_cases
                                                            "
                                                        />
                                                    </div>

                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Amount Of
                                                            pallet</label
                                                        >
                                                        <input readonly
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            @input="
                                                                checkPerAmount(
                                                                    index
                                                                )
                                                            "
                                                            
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .amount_pallet
                                                            "
                                                        />
                                                    </div>

                                                    <!-- <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Total Amount pallet</label
                                                        >
                                                        <input
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            v-on:keydown="
                                                                checkNumber(
                                                                    $event
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .total_amount_pallet
                                                            "
                                                        />
                                                    </div> -->

                                                </div>
                                            </td>
                                        </tr>
                                        <!-- <tr
                                            v-for="(
                                                product, index
                                            ) in orderShipmentSearch.order.products"
                                            :key="product.id"
                                        > -->
                                        <tr
                                        v-for="(
                                                product, index
                                            ) in orderNew.products.filter(
                                                (x) =>
                                                    x.id != null &&
                                                    form.products.filter(
                                                        (y) => y.id === x.id
                                                    ).length === 0
                                            )"
                                            :key="product.id"
                                            >
                                            <td>
                                                <div
                                                    class="custom-control custom-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        :value="product.id"
                                                        :id="'id_' + product.id"
                                                        name="uns_prod_ids[]"
                                                        :checked="false"
                                                        @click="
                                                            selectProductCheckbox(
                                                                product,
                                                                $event
                                                            )
                                                        "
                                                    />
                                                    <label
                                                        class="custom-control-label"
                                                        :for="
                                                            'id_' + product.id
                                                        "
                                                    ></label>
                                                </div>
                                            </td>
                                            <td>
                                                <router-link
                                                    :to="{
                                                        name: 'productsDetails',
                                                        params: {
                                                            id: product.id,
                                                        },
                                                    }"
                                                    target="_blank"
                                                    >{{
                                                        product.product_num
                                                    }}ffff</router-link
                                                >
                                            </td>
                                            <td>
                                                {{ product.product_name }}
                                                <p
                                                    v-html="
                                                        product.product_desc
                                                    "
                                                ></p>
                                            </td>
                                            <td>
                                                {{ product.quantity }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="
                                                    form.is_partially_shipped
                                                "
                                            />
                                            <label class="form-check-label"
                                                >Partially Shipped</label
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6"></div>
                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Total Pallets</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input 
                                                type="text"
                                                class="form-control form-custom"
                                                placeholder=""
                                                v-on:keydown="
                                                    checkNumber(
                                                        $event
                                                    )
                                                "
                                                v-model="
                                                    form.total_pallet_count
                                                "
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                </div>
                            <div class="row">
                                <!-- <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Total Pallets</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input readonly
                                                type="text"
                                                class="form-control form-custom"
                                                placeholder=""
                                                v-on:keydown="
                                                    checkNumber(
                                                        $event
                                                    )
                                                "
                                                v-model="
                                                    form.total_pallet_count
                                                "
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div> -->

                                

                                
                                
                                
                                
                                
                                
                            

                                

                                

                                

                                
                                
                            </div>
                            
                            
                            <div class="mt-3 text-end">
                                <button
                                    type="submit"
                                    :disabled="loading"
                                    class="btn btn-primary fw-semibold fs-14 px-4"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    configure,
} from "vee-validate";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import { mapActions, mapGetters, mapState } from "vuex";

import CustomerSelect from "./CustomerSelect";
import VendorSelect from "./VendorSelect";

configure({
    classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
        // ...
    },
});

extend("positive", (value) => {
    if (value >= 0) {
        return true;
    }

    return "This field must be a positive number";
});

export default {
    name: "AddShippingModalOther",
    props: ["shipping", "order", "po", "loading", "carriers","customerWarehouse","companyWarehouse",
    "orderShipmentSearch"],
    components: {
        ValidationObserver,
        ValidationProvider,
        DatePicker,
        CustomerSelect,
        VendorSelect,
    },
    created() {},
    mounted() {
        console.log("orderShipmentSearch ff",this.orderShipmentSearch);
        let self = this;

        $("#addShippingModalOther").on("show.bs.modal", () => {
            if (self.shipping) {
                self.form.order_id = self.shipping.order_id;

                self.form.customer_id = self.shipping.customer_id;
                self.form.customer = self.shipping.customer;

                self.form.vendor_id = self.shipping.vendor_id;
                self.form.vendor = self.shipping.vendor;

                self.form.purchase_order_id = self.shipping.purchase_order_id;

                self.form.quotation_id = self.shipping.quotation_id;
                self.form.quotation = self.shipping.quotation;

                self.form.source = self.shipping.source;
                self.form.destination = self.shipping.destination;
                self.form.carrier_company = self.shipping.carrier_company;
                self.form.status = self.shipping.status;

                self.form.shipment_type = self.shipping.shipment_type;
                self.form.products = self.orderShipmentSearch.products;
                self.form.carrier_type = self.shipping.carrier_type;
                self.form.shipping_type = self.shipping.shipping_type;
                self.form.tracking_no = self.shipping.tracking_no;
                self.form.tracking_url = self.shipping.tracking_url;
                self.form.completed_at = self.shipping.completed_at;
                self.form.eta_departure = self.shipping.eta_departure;
                self.form.eta_arrival = self.shipping.eta_arrival;
                self.form.notes = self.shipping.notes;
                self.is_partially_shipped = self.shipping.is_partially_shipped;
            } else {
                console.log("order order",this.order);
                console.log("order order",this.po);
                
                console.log("this.$route.params.id",this.$route.params.id);
                console.log("order shipping data ",this.orderShipmentSearch);
                this.getOrder();
                 self.form.order_id = this.po.id;
                 self.form.purchase_order_id = this.$route.params.id;
                 self.form.customer_id = this.po.customer_id;

                self.form.shipment_type = self.orderShipmentSearch.shipment_type;
                //self.form.products = self.orderShipmentSearch.order.products;

                console.log("self.form.products ",self.form.products);
                self.form.carrier_type = self.orderShipmentSearch.carrier_type;
                self.form.shipping_type = self.orderShipmentSearch.shipping_type;
                self.form.tracking_no = self.orderShipmentSearch.tracking_no;
                self.form.tracking_url = self.orderShipmentSearch.tracking_url;
                self.form.completed_at = self.orderShipmentSearch.completed_at;
                self.form.eta_departure = self.orderShipmentSearch.eta_departure;
                self.form.eta_arrival = self.orderShipmentSearch.eta_arrival;
                self.form.notes = self.orderShipmentSearch.notes;


                if (self.po.is_stocking) {
                    if (self.po.warehouses && self.po.warehouses.length) {
                        if (self.po.warehouses[0].warehouse) {
                            self.form.destination = `${self.po.warehouses[0].warehouse.address} ${self.po.warehouses[0].warehouse.address2} ${self.po.warehouses[0].warehouse.city} ${self.po.warehouses[0].warehouse.state} ${self.po.warehouses[0].warehouse.post_code}`;
                        } else {
                            self.form.destination =
                                self.po.warehouses[0].address;
                        }
                    }
                } else {
                    if (
                        self.po.customer_warehouses &&
                        self.po.customer_warehouses.length
                    ) {
                        if (self.po.customer_warehouses[0].warehouse) {
                            self.form.destination = `${self.po.customer_warehouses[0].warehouse.address} ${self.po.customer_warehouses[0].warehouse.address2} ${self.po.customer_warehouses[0].warehouse.city} ${self.po.customer_warehouses[0].warehouse.state} ${self.po.customer_warehouses[0].warehouse.post_code}`;
                        } else {
                            self.form.destination =
                                self.po.customer_warehouses[0].address;
                        }
                    }
                }
            }
        });

        $(this.$refs.addShippingModalOther).on("hidden.bs.modal", function () {
            self.form = {
                order_id: null,
                customer: null,
                customer_id: null,
                vendor: null,
                vendor_id: null,
                purchase_order_id: null,
                source: null,
                destination: null,
                shipment_type: null,
                products: [],
                carrier_type: null,
                total_pallet_count:null,
                shipping_type: null,
                carrier_company: null,
                status: 1,
                tracking_no: null,
                tracking_url: null,
                completed_at: null,
                eta_departure: null,
                eta_arrival: null,
                notes: null,
                is_partially_shipped: false,
            };

            self.$refs.formValidation.reset();
        });
    },
    data() {
        return {
            tracking_no_label: "MBL NO.",
            orderNew:{
                products:[]
            },
            allCarrier: [
                { id: "Maersk", text: "Maersk" },
                { id: "OOCL", text: "OOCL" },
                { id: "APL", text: "APL" },
                { id: "ONE", text: "ONE" },
                { id: "ZIM", text: "ZIM" },
                { id: "COSCO", text: "COSCO" },
                { id: "Hapag Lloyd", text: "Hapag Lloyd" },
                { id: "Evergreen", text: "Evergreen" },
                { id: "Turkon", text: "Turkon" },
                { id: "Transfer", text: "Transfer" },
                { id: "MSC", text: "MSC" },
                { id: "Wan Hai Lines", text: "Wan Hai Lines" },
                { id: "TS Lines", text: "TS Lines" },
                { id: "SM Line", text: "SM Line" },
                { id: "Yang Ming", text: "Yang Ming" },
                { id: "HMM", text: "HMM" },
                { id: "Hamburg SUD", text: "Hamburg SUD" },
                { id: "CMA CGM", text: "CMA CGM" },
                { id: "UPS", text: "UPS" },
                { id: "Fedex", text: "Fedex" },
                { id: "DHL", text: "DHL" },
                { id: "Other", text: "Other" },
            ],
            checkAll: false,
            shippingTypeOptions: [],
            form: {
                eta: null,
                etd: null,
                order_id: null,
                customer: null,
                customer_id: null,
                carrier_id: null,
                vendor: null,
                vendor_id: null,
                purchase_order_id: null,
                source: null,
                destination: null,
                shipment_type: null,
                products: [],
                carrier_type: null,
                shipping_type: null,
                carrier_company: null,
                status: 1,
                tracking_no: null,
                tracking_url: null,
                completed_at: null,
                eta_departure: null,
                eta_arrival: null,
                notes: null,
                is_partially_shipped: false,
            },
            customers: [],
            vendors: [],
            quotations: [],
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        getOrder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(
                    window.route("purchase-orders.show", {
                        id: this.orderShipmentSearch.purchase_order_id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.labels = _.cloneDeep(data.labels);
                        this.admin_users = _.cloneDeep(data.admin_users);
                        data.data.new_admin_users = [];
                        if (data.data.admin_users) {
                            data.data.admin_users.forEach((x) => {
                                data.data.new_admin_users.push(x.admin);
                            });
                        }

                        if (
                            data.data.order.artworks &&
                            data.data.order.artworks.length > 0 &&
                            data.data.order.latest_artwork == null
                        ) {
                            data.data.order.latest_artwork = _.cloneDeep(
                                data.data.order.artworks[
                                    data.data.order.artworks.length - 1
                                ]
                            );
                        }

                        data.data.products.forEach((x) => {
                            if (
                                x.order_product.artworks &&
                                x.order_product.artworks.length > 0 &&
                                x.order_product.latest_artwork == null
                            ) {
                                x.order_product.latest_artwork = _.cloneDeep(
                                    x.order_product.artworks[
                                        x.order_product.artworks.length - 1
                                    ]
                                );
                            }
                        });

                        this.orderNew = data.data;
                        this.form.products = data.data.order.products;
                        console.log("this.orderNew",this.orderNew);
                        this.artwork_statuses = data.artwork_statuses;
                        this.eachProductsHasArtwork = false;

                        this.newLabelId = [];
                        this.orderNew.labels.forEach((l) => {
                            this.newLabelId.push(l.id);
                        });

                        if (
                            this.orderNew.order.original_customer_file &&
                            this.order.order.customer_file_media_id &&
                            this.order.order.artworks.length == 0
                        ) {
                            this.orderNew.order.artworks.push({
                                id: null,
                                is_approve: 0,
                                attach_link: null,
                                comment: null,
                                updated_at: null,
                                media_id: null,
                                artwork_status_id: 1,
                                customer_file_media_id:
                                    this.order.order.customer_file_media_id,
                            });
                        }

                        if (this.orderNew.products && this.order.products.length) {
                            this.eachProductsHasArtwork =
                                this.orderNew.products.filter(
                                    (x) =>
                                        x.id &&
                                        x.order_product &&
                                        x.order_product.artworks &&
                                        x.order_product.artworks.filter(
                                            (y) => y.id && y.attach_link != null
                                        ).length > 0
                                ).length > 0;
                            this.sub_total_cost = 0;
                            this.orderNew.products.forEach((x, index) => {
                                if (!isNaN(parseInt(x.cost))) {
                                    this.sub_total_cost += parseInt(x.cost);
                                }
                                if (
                                    x.order_product &&
                                    x.order_product.artworks &&
                                    x.order_product.artworks.length
                                ) {
                                    this.orderNew.products[index].artworks =
                                        _.cloneDeep(x.order_product.artworks);
                                    this.orderNew.products[index].latest_artwork =
                                        _.cloneDeep(
                                            x.order_product.latest_artwork
                                        );

                                    if (
                                        x.order_product
                                            .original_customer_file &&
                                        x.order_product.uploaded_media_id &&
                                        this.order.products[index].artworks
                                            .length == 0
                                    ) {
                                        x.artworks.push({
                                            id: null,
                                            is_approve: 0,
                                            attach_link: null,
                                            comment: null,
                                            updated_at: null,
                                            media_id: null,
                                            artwork_status_id: 1,
                                            customer_file_media_id:
                                                x.order_product
                                                    .uploaded_media_id,
                                        });
                                    }
                                }
                            });
                        }
                        
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        checkCaseNumber(index) {
            console.log("index", index);
            //console.log("event", event);
            // console.log(
            //     "this.form.products[index].pcs_per_case",
            //     this.form.products[index].pcs_per_case
            // );

            if(this.form.products[index].pcs_per_case != '' && this.form.products[index].cases_per_pallet){
                this.form.products[index].total_cases = Math.ceil(this.form.products[index].quantity / (this.form.products[index].pcs_per_case));
                this.form.products[index].amount_pallet = this.form.products[index].total_cases / this.form.products[index].cases_per_pallet;
                // Math.ceil(this.form.products[index].quantity / (this.form.products[index].cases_per_pallet * this.form.products[index].pcs_per_case));
            }
            
            // console.log(
            //     "calculate ",
            //     this.form.products[index].pcs_per_case * 50
            // );

            // this.form.products[index].cases_per_pallet =
            //     this.form.products[index].pcs_per_case * 50;
        },

         checkPerAmount(index) {
            console.log("index", index);
            //console.log("event", event);
            console.log(
                "this.form.products[index].pcs_per_case",
                this.form.products[index].pcs_per_case
            );

            // if(this.form.products[index].amount_per_pallet){

            //    this.form.products[index].total_amount_pallet = this.form.products[index].total_pallet * this.form.products[index].amount_per_pallet
            // }
            let i = 0;
            for(i = 0;i < this.form.products.length;i++){
                console.log("pallet product ",this.form.products[i])
            }
            // console.log(
            //     "calculate ",
            //     this.form.products[index].pcs_per_case * 50
            // );

            // this.form.products[index].cases_per_pallet =
            //     this.form.products[index].pcs_per_case * 50;
        },

        checkAllEvent(event) {
            this.orderShipmentSearch.order.products.forEach((x) => {
                this.selectProduct(x, event.target.checked);
            });
        },
        selectProductCheckbox(product, event) {
            console.log("product selectProductCheckbox",product);
            this.selectProduct(product, event.target.checked);
        },
        selectProduct(product, checked) {
            if (checked === null) {
                checked = !(
                    this.form.products.filter((x) => x.id === product.id)
                        .length > 0
                );
            }

            if (checked) {
                product.is_partially_shipped = false;
                this.form.products.push(product);
            } else {
                this.form.products = this.form.products.filter(
                    (x) => x.id !== product.id
                );
            }
        },
        removeProductCheckbox(product) {
            this.selectProduct(product, false);
        },
        customerSelected(event) {
            console.log(event);
            if (event != null) {
                this.form.customer = event;
                this.form.customer_id = event.id;
            } else {
                this.form.customer = null;
                this.form.customer_id = null;
            }
        },
        vendorSelected(event) {
            console.log(event);
            if (event != null) {
                this.form.vendor = event;
                this.form.vendor_id = event.id;
            } else {
                this.form.vendor = null;
                this.form.vendor_id = null;
            }
        },
        submitHandler() {
            console.log("this.form",this.form);
            console.log("this.order",this.order);
            console.log("this.order",this.po);
            //return ;
            this.$refs.formValidation.validate().then((success) => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);

                if (this.shipping) {
                    return axios
                        .put(
                            window.route("updateShipping", {
                                id: this.shipping.order_id,
                                shipping_id: this.shipping.id,
                            }),
                            this.form,
                            {
                                validateStatus: function (status) {
                                    return status < 500; // Resolve only if the status code is less than 500
                                },
                            }
                        )
                        .then(({ data }) => {
                            if (
                                data.errors &&
                                Object.keys(data.errors).length
                            ) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage(
                                    "Shipping updated successfully!"
                                );
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit("updatedEvent", data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(
                                error.response && error.response.errorMessage
                                    ? error.response.errorMessage
                                    : error.message
                            );
                        })
                        .finally(() => {
                            self.setLoading(false);
                        });
                } else {
                    return axios
                        .post(
                            window.route("addShippingOther", { id: this.po.id }),
                            this.form,
                            {
                                validateStatus: function (status) {
                                    return status < 500; // Resolve only if the status code is less than 500
                                },
                            }
                        )
                        .then(({ data }) => {
                            if (
                                data.errors &&
                                Object.keys(data.errors).length
                            ) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {

                                $('#addShippingModalOther').modal('toggle');

                                self.setSuccessMessage(
                                    "Shipping added successfully!"
                                );
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit("addedEvent", data);
                                location.reload();
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(
                                error.response && error.response.errorMessage
                                    ? error.response.errorMessage
                                    : error.message
                            );
                        })
                        .finally(() => {
                            self.setLoading(false);
                        });
                }
            });
        },
    },
    computed: {
        ...mapGetters(["commonErrors", "errorMessage", "successMessage"]),
    },
    watch: {
        "form.shipping_type": {
            handler: function (after, before) {
                if (after == "Courier") {
                    this.tracking_no_label = "MBL NO.";
                } else {
                    this.tracking_no_label = "MBL NO.";
                }
            },

            deep: true,
        },
        "form.carrier_company": {
            handler: function (after, before) {
                console.log("form.carrier_company : ", after);
            },

            deep: true,
        },
        "form.carrier_type": {
            handler: function (after, before) {
                if (after == 1) {
                    this.tracking_no_label = "Tracking";
                    //this.shippingTypeOptions = ['FCL','LCL','Parcel'];
                    this.shippingTypeOptions = ["Cargo", "Courier"];
                } else {
                    this.tracking_no_label = "BOL";
                    this.shippingTypeOptions = [
                        //"FCL",
                       //"LCL",
                        "Parcel",
                        "LCL",
                        "FCL 20",
                        "FCL 40",
                    ];
                }
                console.log("shippingTypeOptions", this.shippingTypeOptions);
                console.log("after :", after);
            },

            deep: true,
        },
        "form.customer_warehouse":{
            handler: function (after, before) {
                if (after != null) {
                    let code = after;
                     //console.log(after, code);
                     let carriers = this.customerWarehouse.filter(
                         (x) => x.id == code
                     );
                    if (carriers.length) {
                         this.form.destination = carriers[0].address;
                         
                     }
                    console.log("new data ",carriers);
                }
                 console.log("form.customer_warehouse daat ",this.customerWarehouse);
                console.log("form.customer_warehouse ",after);
            }
        },
        "form.company_warehouse":{
            handler: function (after, before) {
                
                if (after != null) {
                    let code = after;
                     //console.log(after, code);
                     let carriers = this.companyWarehouse.filter(
                         (x) => x.id == code
                     );
                     if (carriers.length) {
                         this.form.destination = carriers[0].address;
                         
                     }

                   //this.form.destination = carriers.address;
                    console.log("new data ",carriers);
                }
                console.log("form.company_warehouse data ",this.companyWarehouse);
                console.log("form.company_warehouse ",after);
            }
        },
         "form.tracking_no": {
            handler: function (after, before) {
                 console.log("this.carriers ", this.carriers);
                 this.form.carrier_company = null;
                 this.form.carrier_id = null;
                 if (after != null && after.length >= 4) {
                     let code = after.substring(0, 4);
                     //console.log(after, code);
                     let carriers = this.carriers.filter(
                         (x) => x.code.toLowerCase() == code.toLowerCase()
                     );
                     //console.log(carriers)
                     if (carriers.length) {
                         this.form.carrier_company = carriers[0].name;
                         this.form.carrier_id = carriers[0].id;
                     }
                 }
             },
             deep: true,
         },
        "form.products": {
            handler: function (value, oldValue) {


                let i = 0;
                let totalPalet = 0;
                for(i = 0;i < this.form.products.length;i++){

                    totalPalet += this.form.products[i].amount_pallet;

                    console.log("pallet product ",this.form.products[i])
                }

                this.form.total_pallet_count = totalPalet;

                console.log("ii ", value);
                if (
                    value != null &&
                    this.orderNew.products != null &&
                    this.orderNew.products.length === value.length
                ) {
                    this.checkAll = true;
                } else {
                    this.checkAll = false;
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.active{
    color:black;
}
</style>
